var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -902,
    y: -648,
    width: 1440,
    height: 1162,
    rx: 20,
    fill: "#FAFAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-902 -628C-902 -639.046 -893.046 -648 -882 -648H518C529.046 -648 538 -639.046 538 -628V494C538 505.046 529.046 514 518 514H-882C-893.046 514 -902 505.046 -902 494V-628Z",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_2392)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: -22,
    width: 480,
    height: 62,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -21,
    width: 478,
    height: 60,
    rx: 7,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8C11.5 6.35 10.15 5 8.50001 5C6.85001 5 5.50001 6.35 5.50001 8C5.50001 9.65 6.85001 11 8.50001 11C10.15 11 11.5 9.65 11.5 8ZM8.50001 9C7.95001 9 7.50001 8.55 7.50001 8C7.50001 7.45 7.95001 7 8.50001 7C9.05001 7 9.50001 7.45 9.50001 8C9.50001 8.55 9.05001 9 8.50001 9ZM15 11C16.11 11 17 10.11 17 9C17 7.89 16.11 7 15 7C13.89 7 12.99 7.89 13 9C13 10.11 13.89 11 15 11ZM10.99 0.0100021C5.47001 0.0100021 0.990005 4.49 0.990005 10.01C0.990005 15.53 5.47001 20.01 10.99 20.01C16.51 20.01 20.99 15.53 20.99 10.01C20.99 4.49 16.51 0.0100021 10.99 0.0100021ZM4.84001 15.12C5.52001 14.58 7.11001 14.01 8.50001 14.01C8.57001 14.01 8.65001 14.02 8.73001 14.02C8.97001 13.38 9.40001 12.73 10.03 12.16C9.47001 12.06 8.94001 12 8.50001 12C7.20001 12 5.11001 12.45 3.77001 13.43C3.27001 12.39 2.99001 11.23 2.99001 10C2.99001 5.59 6.58001 2 10.99 2C15.4 2 18.99 5.59 18.99 10C18.99 11.2 18.72 12.34 18.24 13.37C17.24 12.78 15.88 12.5 15 12.5C13.48 12.5 10.5 13.31 10.5 15.2V17.98C8.23001 17.85 6.21001 16.77 4.84001 15.12Z",
    fill: "#1B59F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_2392",
    x: -37,
    y: -41,
    width: 520,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_2392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_2392",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.6fb0898bb9e9f4b99ea01c080b446e59.svg";
export { ForwardRef as ReactComponent };